//src/pages/RecyleBin

import React, { useContext, useEffect, useState } from "react";
// import Snackbar from "@mui/material/Snackbar";
// import Alert from "@mui/material/Alert";
// import secureLocalStorage from "react-secure-storage";
// import CircularProgress from "@mui/material/CircularProgress";
// import FilesPage from "./FilesGridPage";
// import { useParams } from "react-router-dom";
import { api } from "../utils/axios-instance";
import { useDarkMode } from "../context/darkModeContext";
import useAuth from "../stores/authStore";
import fileContext from "../context/fileContext";
import { useFolderStore } from "../store/folderStore";
import MultipleFileMenu from "../components/MultipleFileMenu";
import RecentDeletedFiles from "../components/RecycleBin/RecentDeletedFiles";
import RecentDeletedFolders from "../components/RecycleBin/RecentDeletdFolders";

const RecycleBin = () => {
  const [filesFromBackend, setFilesFromBackend] = useState([]);
  const [loading, setLoading] = useState(true);
  const [recycleFiles, setRecycleFiles] = useState([]);
  const recycleFolders = useFolderStore((state) => state.recycleFolders);
  const { darkMode } = useDarkMode();

  const [select, setSelect] = useState(false);
  const [showMultiFileOptions, setShowMultiFileOptions] = useState(false);
  const context = useContext(fileContext);
  const {
    departmentFiles,
    setDepartmentFiles,
    refreshRecycleBin,
    setRefreshRecycleBin,
  } = context;

  const profileData = useAuth((state) => state.profileData);
  useEffect(() => {
    setFilesFromBackend(departmentFiles);
  }, [departmentFiles]);

  const removeFiles = () => {
    const idsToRemove = context.selectedFiles.map((file) => file.id);

    const updatedFiles = filesFromBackend.filter(
      (file) => !idsToRemove.includes(file.id)
    );

    setFilesFromBackend(updatedFiles);
  };

  const updateFiles = (file, val) => {
    setFilesFromBackend((prevData) =>
      prevData.map((data) =>
        data.id === file.id ? { ...data, isLocked: val } : data
      )
    );
  };

  useEffect(() => {
    setLoading(true);
    const fetchRecycleBinData = async () => {
      try {
        const response = await api.get("/file/recycle-bin-file");

        console.log("Recycle Bin Files:", response.data);
        if (response && response.data) {
          const deletedFiles = response.data;
          const filteredFiles = deletedFiles.filter(
            (file) =>
              file.owner === profileData.id ||
              profileData.role_priv === "org_admin"
          );
          setRecycleFiles(filteredFiles);
        }
        setRefreshRecycleBin(false);
      } catch (error) {
        console.error("Error fetching recycle bin files:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchRecycleBinData();
  }, [refreshRecycleBin, setRefreshRecycleBin]);
  console.log("Recycle Files:yare ", { recycleFiles });

  const deletedFolderIds = new Set(
    (recycleFolders || []).map((folder) => folder.id)
  );

  const standaloneDeletedFiles = recycleFiles.filter((file) => {
    const folderId = file.folder_id || file.folderId;

    if (!folderId) {
      return true;
    }

    return !deletedFolderIds.has(folderId);
  });

  const filesInsideDeletedFolders = recycleFiles.filter((file) => {
    const folderId = file.folder_id || file.folderId;

    return folderId && deletedFolderIds.has(folderId);
  });

  return (
    <div
      className={`w-full min-h-screen p-4 ${darkMode ? "bg-gray-800 text-white" : "bg-white text-gray-800"}`}
    >
      <p
        className={`text-2xl font-semibold m-2 ${darkMode ? "text-white" : "text-gray-800"}`}
      >
        Recycle Bin
      </p>
      <p className={`ml-2 ${darkMode ? "text-gray-400" : "text-gray-500"}`}>
        Standalone deleted files: {standaloneDeletedFiles.length}
      </p>

      <p className={`ml-2 ${darkMode ? "text-gray-400" : "text-gray-500"}`}>
        Deleted folders: {recycleFolders.length}
        {recycleFolders.length > 0 &&
          ` (${filesInsideDeletedFolders.length} files inside folders)`}
      </p>
      <h2 className="text-xl font-semibold mt-8 mb-4">Deleted Folders</h2>

      <RecentDeletedFolders />

      <span className="flex gap-2">
        {showMultiFileOptions && (
          <MultipleFileMenu removeMultiSelect={() => setSelect(false)} />
        )}
      </span>

      <div className="px-4 mt-4">
        <h2 className="text-xl font-semibold mt-8 mb-4">Deleted Files</h2>
        <RecentDeletedFiles
          recycleFiles={recycleFiles}
          loading={loading}
          select={select}
          setSelect={setSelect}
          showMultiFileOptions={showMultiFileOptions}
          setShowMultiFileOptions={setShowMultiFileOptions}
        />
      </div>
    </div>
  );
};

export default RecycleBin;
